import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import TRANSLATION_EN from "./translation/en/en";
import TRANSLATION_TR from "./translation/tr/tr";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: TRANSLATION_EN
      },
      tr: {
        translation: TRANSLATION_TR
      }
    },
    lng: "tr", // Varsayılan dil
    fallbackLng: "tr", // Yedek dil
    whitelist: ['en', 'tr'],
    detection: {
      order: ["path", "localStorage", "htmlTag", "cookie"],
      caches: ["localStorage", "cookie"], // cache user language on
      checkWhitelist: true
    },
    interpolation: {
      escapeValue: false // React elemanları içinde HTML kaçışı yapılmasına izin ver
    }
  });

export default i18n;
